import { FiTrash, FiX } from "react-icons/fi";
import { TiTick } from "react-icons/ti";

export const attendanceApplicationColumns = (action) => [
	{
		id: "actions",
		header: "View",
		accessor: (row) => (
			<div className="text-center">
				<FiTrash
					style={{ cursor: "pointer" }}
					className={row?.isApproved ? "text-muted" : "text-danger"}
					onClick={() => (row?.isApproved ? {} : action(row))}
				/>
			</div>
		),
		sortable: false,
		filterable: false,
	},
	{
		id: "teacherName",
		header: "Staff",
		accessor: (row) => row?.staff?.fullName,
		sortable: true,
		filterable: true,
	},
	{
		id: "applicationDate",
		header: "Application Date",
		accessor: (row) => row.attendanceDate,
		sortable: true,
		filterable: true,
	},
	{
		id: "applicationCentre",
		header: "Centre",
		accessor: (row) => row?.centre?.shortName,
		sortable: true,
		filterable: true,
	},
	{
		id: "applicationTime",
		header: "Time",
		accessor: (row) => row?.attendanceTime,
		sortable: true,
		filterable: true,
	},
	{
		id: "approved",
		header: "Approved",
		accessor: (row) => (
			<div className="text-center">{row?.isApproved ? <TiTick className="text-success" /> : <FiX className="text-danger" />}</div>
		),
		sortable: true,
		filterable: true,
	},
];
